import React from "react";
import { Link } from "react-router-dom";
import Brand from "../../components/Brand/Brand";
import { localizedPath } from "../../utils/seoLinks";
import { TRIAL_DAYS } from "./content";
import { useHomeLang } from "./homeLang";
import "./trial.css";

const WORDS = {
  it: {
    heading: <>Prova <span className="tr-keep"><Brand>A.V.R.A.H. oggi.</Brand></span><br />{TRIAL_DAYS} giorni gratis.</>,
    note: "Poi da 15 € al mese + IVA con il piano annuale. Nessun addebito oggi.",
    start: "Inizia la prova",
    demo: "Prenota una demo",
  },
  en: {
    heading: <>Try <span className="tr-keep"><Brand>A.V.R.A.H. today.</Brand></span><br />{TRIAL_DAYS} days free.</>,
    note: "Then from €15 a month + VAT on the annual plan. No charge today.",
    start: "Start your free trial",
    demo: "Book a demo",
  },
};

// The offer, words and actions only, across the page's width.
export default function TrialSection() {
  const lang = useHomeLang();
  const words = WORDS[lang];
  return (
    <section id="prova" aria-labelledby="hf-h-trial" className="hf-sec hf-wrap">
      <div className="tr">
        <h2 id="hf-h-trial" className="t-display">
          {words.heading}
        </h2>
        <div className="tr-act">
          <p className="t-lead tr-note">{words.note}</p>
          <div className="tr-ctas">
            <Link className="btn btn-gold" to="/signup">{words.start}</Link>
            <Link className="btn btn-quiet" to={localizedPath("/demo", lang)}>{words.demo}</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
